// src/api_scripts/getdesktopprofiles.js
import { fetchAllPages } from "../paginationUtils";

const getDesktopProfiles = async (desktopprofilesName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/agent-profile`;

  try {
    const dataArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Desktop Profiles");
    console.log("Get Desktop Profiles API Response Data (all pages):", dataArray.length, "items");
    return dataArray;

  } catch (error) {
    console.error(`Error fetching Desktop Profiles:`, error);
    throw error;
  }
};

export default getDesktopProfiles;